<template>
  <div id='wrap'>
        <!-- 回到顶部 -->
   <!-- <el-backtop :bottom="100"></el-backtop> -->
   <el-backtop  :bottom="100" class="backtop">
     <div >
      回<br/>到<br/>顶<br/>部
     </div>
    <div>
      ↑
    </div>
  </el-backtop>
    <!-- 头部 -->
    <Header></Header>
    <!-- 中间routerlink部分 -->
    <router-view></router-view>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './components/Header/Header.vue'
import Footer from './components/Footer/Footer.vue'
  export default {
    components:{
      Header,
      Footer
    }
  }
</script>

<style lang="scss"scoped>
</style>
<style lang="scss">
#wrap{
  .backtop{
    width: 44px;
    height: 44px;
     border-radius:0 ;
    div:nth-child(1){
      width: 44px;
      height: 108px;
      background-color: #26C9A5;
      font-weight: 600;
      color: white;
      display: flex;
      align-items: center;
      text-align: center;
      justify-content: center;
      font-size: 16px;
      position: absolute;
      left: 0;
      top: -115px;
    }
  }
}
</style>

